<!--负荷图表-->
<template>
	<div class="realTimeLoadBody" :style="backImg('/huapu/discountBox.png')">
		<vchart ref='vchartLine' themes="purple-passion" ></vchart>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				todayLoadLine: [],
				loadcapacity: 0,
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.getLoadValue()
		},
		destroyed() {},
		computed: {
			imgName() {
				return resourcesStore.getters.getResourcesByName
			},
			backImg() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			xList() {
				var list = []
				for(var h = 0, len = 24; h < len; h++) {
					for(var m = 0, lenm = 60; m < lenm; m += 5) {
						list.push((h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m)
					}
				}
				return list
			},
			getLine() {
				return {
					xAxis: {
						type: 'category',
						axisLabel: {
							textStyle: {
								color: '#fff'
							},
						},
						axisLine: {
							show: false

						},
						data: this.xList,
					},
					yAxis: {
						type: 'value',
						nameTextStyle: {
							color: '#FFF',
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							},
						},
						axisLine: {
							show: false

						},
					},
					legend: {
						data: [{
							name: '昨日用水量',
							textStyle: {
								color: '#4d89b0'
							}
						}, {
							name: '今日用水量',
							textStyle: {
								color: '#ded45e'
							}
						}],
						right: '10px',
						top: '10px',
						width: '20px',
						icon: "circle",
						show: true,
						plain: 'scroll'
					},
					backgroundColor: '',
					series: this.todayLoadLine
				}
			},
			transformerList() {
				return this.$store.cacheStore.state.transformerList
			}
		},
		watch: {
			getLine(nv, ov) {
				this.$refs.vchartLine.setData(nv)
			},
			transformerList(nv, ov) {
				this.getLoadValue()
			}
		},
		methods: {
			getLoadValue() {
				var deviceNos = ''
				this.transformerList.forEach((item, index) => {
					if(this.transformerList.length == index + 1) {
						deviceNos += item.no
					} else {
						deviceNos += item.no + ','
					}
				})
				//获取当日负荷曲线
				var ser = []
				this.$api.powerApi.getUnitDayLoadValuesNos('', new Date(getDay(-1) + ' 00:00:00').getTime(), deviceNos, respon => {
					ser.push({
						data: respon,
						type: 'line',
						stack: '总负荷',
						lineStyle: {
							color: '#4d89b0',
						},
						itemStyle: {
							color: '#4d89b0',
							opacity: 0,
						},
						areaStyle: {
							color: '#4d89b0',
							opacity: 1
						},
						name: '昨日负荷'
					})
				})
				this.$api.powerApi.getUnitDayLoadValuesNos('', new Date(getDay(0) + ' 00:00:00').getTime(), deviceNos, respon => {
					ser.push({
						data: respon,
						stack: '总负荷',
						lineStyle: {
							color: '#ded45e'
						},
						itemStyle: {
							color: '#ded45e',
							opacity: 0,
						},
						areaStyle: {
							color: '#ded45e',
							shadowColor: 'rgba(0, 0, 0, 120)',
							opacity: 1
						},
						type: 'line',
						name: '今日负荷'
					})
					this.todayLoadLine = ser
				})
			},
		}
	}
</script>

<style scoped>
	.realTimeLoadBody {
		width: calc(100% - 20px);
		margin: 10px;
		height: calc(100% - 20px);
	}
	
	.realTimeLoadBody .default-chart {
		height: 100%;
		width: 100%;
	}
</style>